import { cbi_waste_sub_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiWasteSubTypeEnum = (enumValue: cbi_waste_sub_type_enum) => {
  switch (enumValue) {
    case cbi_waste_sub_type_enum.BULKY:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-BULKY" />;
    case cbi_waste_sub_type_enum.CONSTRUCTION_AND_EXCAVATION:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-CONSTRUCTION_AND_EXCAVATION" />;
    case cbi_waste_sub_type_enum.ELECTRONIC_EQUIPMENT:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-ELECTRONIC_EQUIPMENT" />;
    case cbi_waste_sub_type_enum.GLASS:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-GLASS" />;
    case cbi_waste_sub_type_enum.ORGANIC:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-ORGANIC" />;
    case cbi_waste_sub_type_enum.OTHER_NON_RECYCLABLES:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-OTHER_NON_RECYCLABLES" />;
    case cbi_waste_sub_type_enum.OTHER_RECYCLABLES:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-OTHER_RECYCLABLES" />;
    case cbi_waste_sub_type_enum.PACKAGING:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-PACKAGING" />;
    case cbi_waste_sub_type_enum.PAPER:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-PAPER" />;
    case cbi_waste_sub_type_enum.RESIDUAL_WASTE:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-RESIDUAL_WASTE" />;
    case cbi_waste_sub_type_enum.WOOD:
      return <Trans i18nKey="Enum_CbiWasteSubTypeEnum-WOOD" />;
  }
};

export const translateCbiWasteSubTypeEnum_dynamic = (enumValue: cbi_waste_sub_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_waste_sub_type_enum.BULKY:
      return t('Enum_CbiWasteSubTypeEnum-BULKY');
    case cbi_waste_sub_type_enum.CONSTRUCTION_AND_EXCAVATION:
      return t('Enum_CbiWasteSubTypeEnum-CONSTRUCTION_AND_EXCAVATION');
    case cbi_waste_sub_type_enum.ELECTRONIC_EQUIPMENT:
      return t('Enum_CbiWasteSubTypeEnum-ELECTRONIC_EQUIPMENT');
    case cbi_waste_sub_type_enum.GLASS:
      return t('Enum_CbiWasteSubTypeEnum-GLASS');
    case cbi_waste_sub_type_enum.ORGANIC:
      return t('Enum_CbiWasteSubTypeEnum-ORGANIC');
    case cbi_waste_sub_type_enum.OTHER_NON_RECYCLABLES:
      return t('Enum_CbiWasteSubTypeEnum-OTHER_NON_RECYCLABLES');
    case cbi_waste_sub_type_enum.OTHER_RECYCLABLES:
      return t('Enum_CbiWasteSubTypeEnum-OTHER_RECYCLABLES');
    case cbi_waste_sub_type_enum.PACKAGING:
      return t('Enum_CbiWasteSubTypeEnum-PACKAGING');
    case cbi_waste_sub_type_enum.PAPER:
      return t('Enum_CbiWasteSubTypeEnum-PAPER');
    case cbi_waste_sub_type_enum.RESIDUAL_WASTE:
      return t('Enum_CbiWasteSubTypeEnum-RESIDUAL_WASTE');
    case cbi_waste_sub_type_enum.WOOD:
      return t('Enum_CbiWasteSubTypeEnum-WOOD');
  }
};
